import { gql, useMutation } from '@apollo/client';

import { GET_APPLICANT_BY_ID } from './get-applicant-by-id.hook';
import { GET_APPLICANTS_BY_VACANCY } from './get-applicants-by-vacancy.hook';

export const SEND_APPLICANT_EMAIL_TEMPLATE = gql`
  mutation sendApplicantEmailTemplate(
    $applicantId: ObjectId!
    $emailTemplateId: ObjectId!
    $status: String!
  ) {
    sendApplicantEmailTemplate(
      applicantId: $applicantId
      emailTemplateId: $emailTemplateId
      status: $status
    )
  }
`;

export const useSendApplicantEmailTemplate = ({ onSuccess }: { onSuccess: () => void }) => {
  const [sendEmailTemplate] = useMutation(SEND_APPLICANT_EMAIL_TEMPLATE, {
    refetchQueries: [GET_APPLICANTS_BY_VACANCY, GET_APPLICANT_BY_ID],
    onCompleted: onSuccess,
  });

  return { sendEmailTemplate };
};
